import React, { createContext, useReducer } from 'react'
import contactReducer from './contactReducer'
import { SET_CONTACT_MODAL } from '../types'
import ContactModal from '../../components/ContactModal'

const ContactContext = createContext()

const ContactState = ({ children }) => {
  const initialState = {
    contactModal: {
      show: false
    }
  }

  const [state, dispatch] = useReducer(contactReducer, initialState)

  const openContactModal = () => {
    setContactModal({ ...state.contactModal, show: true })
  }

  const closeContactModal = () => {
    setContactModal({ ...state.contactModal, show: false })
  }

  const setContactModal = (data) => {
    dispatch({ type: SET_CONTACT_MODAL, payload: data })
  }

  return (
    <ContactContext.Provider value={{
      openContactModal,
    }}>
      {children}
      <ContactModal showModal={state.contactModal.show} onClose={closeContactModal} />
    </ContactContext.Provider>
  )
}

export default ContactState
export { ContactContext }